<template>
  <div v-if="currentSlide" class="slideshow-container" v-hammer:swipe="swipe" v-hammer:pan="pan">
    <div class="icons" @click.stop>
      <div class="favourite-icon" @click="toggleFavourite()" style="margin-right: 50px;">
        <i v-if="currentSlide.favourite" class="fa fa-heart fa-2x red"></i>
        <i v-else class="far fa-heart fa-2x"/>
      </div>
      <div class="autoplay" @click="toggleAutoplay()">
        <i v-if="!playing" class="fa fa-play fa-2x"/>
        <i v-else class="fa fa-pause fa-2x"/>
      </div>
      <div class="close-icon" @click="close()"><i class="fa fa-times fa-2x"/></div>
    </div>
    <div class="controls">
      <div class="left" @click="prev()">
        <i class="fa fa-chevron-left fa-2x"/>
      </div>
      <div class="right" @click="next()">
        <i class="fa fa-chevron-right fa-2x"/>
      </div>
    </div>
    <div class="slide-container" @click="toggleFavourite()">
      <img :src="currentSlide.url" class="image" :style="moveImage"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Slideshow',
  props: {
    slides: {
      type: Array,
      required: true,
    },
    startIndex: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      playing: false,
      playID: null,

      panX: 0,
    }
  },
  created() {
    window.addEventListener('keydown', this.handleKeypress)
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleKeypress)
  },
  methods: {
    prev() {
      let i = this.startIndex
      if(i > 0) 
         i--
      else
        i = this.slides.length-1
      this.$emit('update:startIndex', i)
      this.panX = 0
    },
    next() {
      let i = this.startIndex
      if(i < this.slides.length-1) 
        i++
      else 
        i = 0
      this.$emit('update:startIndex', i)
      this.panX = 0
    },
    toggleFavourite() {
      // FIXME: emit img src not index
      this.$emit('toggle-favourite', this.slides[this.startIndex])
    },
    swipe(e) {
      if(e.direction == 2)
        this.next()
      if(e.direction == 4)
        this.prev()
    },
    pan(e) {
      console.dir(e)
      this.panX = e.deltaX
    }, 
    toggleAutoplay() {
      if(!this.playing) {
        this.playID = setInterval(() => this.next(), 2000)
        this.playing = true
      }
      else {
        clearInterval(this.playID)
        this.playing = false
      }
    },
    close() {
      if(this.playing)
        this.toggleAutoplay()
      this.$emit('close')
    },
    handleKeypress(e) {
      if(e.key == 'ArrowRight') {
        this.next()
      }
      if(e.key == 'ArrowLeft') {
        this.prev()
      }
      // TODO: up down -> favourite
    }
  },
  computed: {
    currentSlide() {
      return this.slides[this.startIndex]
    },
    moveImage() {
      return 'transform: translateX(' + this.panX + 'px);'
    }
  },
  watch: {
    currentSlide() {
      this.panX = 0
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';

.slideshow-container {
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
}

.slide-container {
  width: 90%;
  height: 90%;
  max-width: 90%;
  max-height: 90%;
  z-index: 1001;
  // background-color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  .image {
    width: 100%;
    height: 100%;
    max-width: 100%;
    transition: 0.3s all;
    object-fit: contain;
    overflow: hidden;
    
    // &:hover {
      //   transform: scale(1.1);
    // }
  }
}

.icons {
  position: fixed;
  top: 0px;
  right: 0px;
  display: inline-block;
  color: rgba(255, 255, 255, 0.2);
  padding: 20px;
  transition: 0.1s all;
  z-index: 1002;

  div {
    display: inline-block;
    cursor: pointer;
    margin-left: 20px;

    &:hover {
      color: rgba(255, 255, 255, 0.9);
    }
  }
}

.controls {
  color: rgba(255, 255, 255, 0.2);

  .left, .right {
    position: fixed;
    padding: 20px;
    cursor: pointer;
    transition: 0.1s all;
    transform: translate(0, -50%);

    &:hover {
      color: rgba(255, 255, 255, 0.9);
    }
  }
  .left {
    top: 50%;
    left: 10px;
  }
  .right {
    top: 50%;
    right: 10px;
  }
}
</style>